import { getStroage } from 'utils'

// 自定义 redux 中间件 - 退出登录，清除 redux 状态
export const logout = () => next => action => {
    const token = getStroage('token')
    if (!token) {
        action.payload = null
    }
    next(action)
}
